import { RouteConfig } from 'vue-router'

const About = () => import('../views/sports-course/About.vue')
const Report = () => import('../views/sports-course/Report.vue')
const Landing = () => import('../views/sports-course/Landing.vue')
const Details = () => import('../views/sports-course/Details.vue')
const Share = () => import('../views/sports-course/Share.vue')
const FollowUs = () => import('../views/sports-course/FollowUs.vue')
const BindUser = () => import('../views/sports-course/BindUser.vue')

export const aboutRoute: RouteConfig = {
  path: '/sports-course/about',
  name: 'sports_course_about',
  component: About,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '天天跳绳会员课程系列',
  },
}

export const reportRoute: RouteConfig = {
  path: '/sports-course/report',
  name: 'sports_course_report',
  component: Report,
  props: (_route) => ({
    ..._route.params,
    ..._route.query,
    id: _route.query.group_record_id || _route.query.id,
  }),
  meta: {
    title: '课程报告',
  },
}

export const landingRoute: RouteConfig = {
  path: '/sports-course/landing',
  name: 'sports_course_landing',
  component: Landing,
  props: (_route) => ({
    ..._route.params,
    ..._route.query,
    qd: `${_route.query.ref_id}:${_route.query.plan_id}`,
  }),
  meta: {
    title: '长高专家',
  },
}

export const detailsRoute: RouteConfig = {
  path: '/sports-course/details',
  name: 'sports_course_details',
  component: Details,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '课程详情',
  },
}

export const shareRoute: RouteConfig = {
  path: '/sports-course/share',
  name: 'sports_course_share',
  component: Share,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '课程分享',
  },
}

export const followUsRoute: RouteConfig = {
  path: '/sports-course/follow-us',
  name: 'sports_course_follow_us',
  component: FollowUs,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '关注服务号',
  },
}

export const bindUserRoute: RouteConfig = {
  path: '/sports-course/bind-user',
  name: 'sports_course_bind_user',
  component: BindUser,
  props: (_route) => ({ ..._route.params, ..._route.query }),
  meta: {
    title: '绑定用户账号',
    needLogin: true,
  },
}

export default [aboutRoute, reportRoute, landingRoute, detailsRoute, shareRoute, followUsRoute, bindUserRoute]
